import DropAutoComplete from './dropdown.vue'

export default DropAutoComplete
